import React from "react";
import PropTypes from "prop-types";
import IconMC from "./IconMC";

/**
 * LabelMC
 * Componente completamente personalizable para mostrar una etiqueta de ayuda humana.
 *
 * Props:
 * - label: string | ReactNode - Texto o nodo a mostrar
 * - iconName: string - Nombre del ícono (por defecto 'hand-outline')
 * - iconClassName: string - Clases adicionales para el ícono
 * - iconSize: string - Tamaño del ícono (por defecto 'xs')
 * - className: string - Clases adicionales para el contenedor
 * - style: object - Estilos en línea opcionales
 */
const LabelMC = React.memo(({
  label,
  iconName,
  iconClassName = "tw-ml-1",
  iconSize = "xs",
  className = "",
  style = {},
  ...rest
}) => {
  return (
    <div
      className={`tw-inline-flex tw-items-center tw-py-[2px] tw-px-[8px] tw-rounded-md tw-font-medium tw-text-2xs ${className}`}
      style={style}
      {...rest}
    >
      {label}
      {iconName && <IconMC name={iconName} className={iconClassName} size={iconSize} />}
    </div>
  );
});

LabelMC.displayName = "LabelMC";

LabelMC.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  iconName: PropTypes.string,
  iconClassName: PropTypes.string,
  iconSize: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

export default LabelMC;
